import { useQuery } from '@tanstack/react-query'

import { env } from '@/config/env'
import { metricsApi } from '@/lib/api'
import { queryKeys } from '@/lib/queryClient'

export function useMetricsOverview(hours: number) {
  return useQuery({
    queryKey: queryKeys.metricsOverview(hours),
    queryFn: () => metricsApi.overview(hours),
    refetchInterval: env.pollIntervalMs * 2,
  })
}

export function useToolPerformance(hours: number) {
  return useQuery({
    queryKey: queryKeys.metricsTools(hours),
    queryFn: () => metricsApi.tools(hours),
    refetchInterval: env.pollIntervalMs * 2,
  })
}

export function useErrorBreakdown(hours: number) {
  return useQuery({
    queryKey: queryKeys.metricsErrors(hours),
    queryFn: () => metricsApi.errors(hours),
    refetchInterval: env.pollIntervalMs * 2,
  })
}
